import { RootState } from '..';

export const selectTimeline = (state: RootState) => {
  return state.timeline.data.items;
};
export const selectIsRealTimeMode = (state: RootState) => {
  return state.timeline.data.settings.isRealTimeMode;
};
